// Le web n'a pas de mise à jour OTA : un onglet rouvert sert déjà le dernier déploiement.
export const useForegroundUpdate = () => {}
